import useAPI from '@/hooks/useAPI';
import PersonRepository from '@/repositories/PersonRepository';

const usePaymentTypes = (enabled = true) => {
  const personRepository = PersonRepository();

  return useAPI({
    queryKey: ['getPaymentTypes'],
    queryFn: async () => {
      return await personRepository.getPaymentTypes();
    },
    enabled
  });
};

export default usePaymentTypes;
